import React, { useState } from "react";
import { useDispatch } from "react-redux";

import CollapsibleMenu from "src/components/common/CollapsibleMenu";
import { ModalActions } from "src/redux/Modal/actions";
import ContactUs from "../../ReferenceData/ContactUs";
import { isMultiplierValid } from "src/utils/validators";
import { TX_INIT_ERROR_MESSAGES } from "src/redux/Tx/constants";

import styles from "./styles.module.scss";

export default (props) => {
    const dispatch = useDispatch();
    const { apply, hasAccess } = props;
    const [multiplier, setMultiplier] = useState(1);
    const [error, setError] = useState(false);
    const applyBenchmarkFee = () => {
        if (hasAccess) {
            apply(multiplier);
        } else {
            dispatch(
                ModalActions.Open(ContactUs, {
                    rounded: true,
                    width: 684,
                    height: 266,
                    title: "Contact Us for Full Access",
                })
            );
        }
    };

    return (
        <CollapsibleMenu title="Reference Rate" dataTestId="ref-rate">
            <div className={styles.referenceRate}>
                <div
                    className={`${styles.settingArea} ${
                        error ? styles.error : ""
                    }`}
                >
                    <div className={styles.subTitle}>
                        <span>
                            S&P Global
                            <br />
                            Benchmark Fee
                        </span>
                    </div>
                    <div className={styles.multiplier} />
                    <input
                        value={multiplier}
                        data-testid="benchmark-fee-input"
                        aria-label="bench mark fee"
                        disabled={!hasAccess}
                        onKeyDown={(e) => {
                            if (!error && e.key === "Enter") {
                                e.preventDefault();
                                applyBenchmarkFee();
                            }
                        }}
                        onChange={(e) => {
                            if (isNaN(e.target.value)) return;
                            setError(!isMultiplierValid(e.target.value));
                            setMultiplier(e.target.value);
                        }}
                    />
                    <button
                        data-testid="benchmark-fee-apply"
                        disabled={error}
                        onClick={applyBenchmarkFee}
                    >
                        Apply
                    </button>
                </div>
                <div>
                    {error && (
                        <div
                            data-testid="ref-rate-error"
                            className={styles.errorMessage}
                        >
                            <span>{TX_INIT_ERROR_MESSAGES.multiplier}</span>
                        </div>
                    )}
                </div>
            </div>
        </CollapsibleMenu>
    );
};
